// .................... contractTypes
export const contractTypes = {
  lease: 'Lease',
  pma: 'Pma',
  offPlan: 'Offplan',
  musataha: 'Musataha',
  mortgage: 'Mortgage',
  poa: 'Poa',
};

export default {};
